import React from "react";

export const buildColumns = () => {
    return [
        {
            Header: () => <h3 style={{ margin: "10px 0" }}>Attribute Name</h3>,
            accessor: "name",
            filterable: false,
            sortable: false,
        },
        {
            Header: () => <h3 style={{ margin: "10px 0" }}>Attribute Format</h3>,
            accessor: "componentType",
            filterable: false,
            sortable: false,
        },
    ];
};
